<template>
  <v-card style="height: 100%; background: transparent;" flat>
    <v-item-group mandatory v-model="filterToggle" active-class="white--text">
      <v-subheader style="display: inline; cursor: default;">Filter:</v-subheader>
      <v-item>
        <v-chip slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
          {{ numberWithCommas(currentSelection.length) }} Selected Cell
        </v-chip>
      </v-item>
      <v-item>
        <v-chip slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
          {{ numberWithCommas(pendingLogs.length) }} Pending
        </v-chip>
      </v-item>
      <v-item>
        <v-chip slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
          <v-icon class="mr-1">rule</v-icon>
          Checked
        </v-chip>
      </v-item>
    </v-item-group>
    <template>
      <v-data-table :headers="headers" :pagination.sync="pagination" :items="filteredLogs" select-all v-model="selectedLogs" :rowsPerPageItems="rowsPerPageItems" class="execution-detailed-logs mt-1 five-items" :no-data-text="noDataText">
        <template v-slot:headers="props">
          <tr>
            <th v-if="isTenantAdmin" class="cell-min-width pl-3 pr-0">
              <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details color="secondary" @click.stop="toggleAll"></v-checkbox>
            </th>
            <th :style="`text-align: ${header.align}`" @click="changeSort(header)" v-for="header in props.headers" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', ...header.classes]" class="px-2" :key="header.text">
              <v-icon small v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <td v-if="isTenantAdmin" class="cell-min-width text-xs-left pl-3 pr-0">
              <v-checkbox color="default" hide-details v-model="props.selected" label />
            </td>
            <td class="cell-min-width pl-3 pr-3" style="position: relative;">
              <v-icon class="icon-shadow" :color="getStatus(props.item).color">{{ getStatus(props.item).icon }}</v-icon>
            </td>
            <td class="text-xs-left px-0">
              <v-tooltip v-if="logsMeta[props.item.location].displayName != logsMeta[props.item.location].fullName" left>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="location-btn" @click="setSelected(props.item)" small>{{ logsMeta[props.item.location].displayName }}</v-btn>
                </template>
                <span>{{ props.item.fullName }}</span>
              </v-tooltip>
              <v-btn v-else class="location-btn" @click="setSelected(props.item)" small>{{ logsMeta[props.item.location].displayName }}</v-btn>
            </td>
            <td class="text-xs-left pl-2 pr-2 cell-max-width">{{ props.item.details }}</td>
          </tr>
        </template>
      </v-data-table>
      <div v-if="isTenantAdmin">
        <Ignore :logs="selectedLogs" />
      </div>
      <v-divider />
    </template>
  </v-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { numberWithCommas } from '@/helpers/numbers'

  const ingestionResults = createNamespacedHelpers('reviewingestionresults')
  const authenticate = createNamespacedHelpers('authenticate')

  import Ignore from './Actions/Ignore'
  import Reset from './Actions/Reset'

  const SEARCH_KEY = 'severityNumber'

  export default {
    components: {
      Ignore,
      Reset,
    },
    data: () => ({
      noDataText: 'No logs found',
      filterToggle: 1,
      filterToggles: {
        SELECTED: 0,
        PENDING: 1,
        ACKNOWLEDGED: 2,
        ALL: 3,
      },
      pagination: {
        sortBy: SEARCH_KEY,
        rowsPerPage: 5,
        page: 1,
      },
      rowsPerPageItems: [5],
      headers: [{
        text: 'Status',
        align: 'center',
        value: 'severityNumber',
        classes: 'cell-min-width',
        sortable: true,
      },
      {
        text: 'Location',
        align: 'left',
        sortable: false,
        value: 'parsedLocation',
      },
      {
        text: 'Details',
        align: 'left',
        sortable: false,
        value: 'details',
      },
      ],
      colorMap: {
        error: 'red',
        warning: 'yellow',
        info: 'blue',
      },
      selectedLogs: [],
    }),
    computed: {
      ...ingestionResults.mapGetters(['logsMeta', 'locationPrinter', 'dirtyData', 'selectedLocation', 'metadata', 'getMetadatumLocation', 'shownLogs']),
      ...authenticate.mapGetters(['isTenantAdmin']),
      filteredLogs() {
        if (this.filterToggle == this.filterToggles.SELECTED) {
          this.noDataText = 'The selected cell has no logs.'
          return this.currentSelection
        } else if (this.filterToggle == this.filterToggles.PENDING) {
          this.noDataText = 'There are no pending logs.'
          return this.pendingLogs
        } else if (this.filterToggle == this.filterToggles.ACKNOWLEDGED) {
          this.noDataText = 'You haven\'t checked any logs.'
          return this.acknowledgedLogs
        } else {
          this.noDataText = 'No logs were found'
          return this.shownLogs
        }
      },
      currentSelection() {
        return this.shownLogs.filter(log => log.location == this.selectedLocation)
      },
      acknowledgedLogs() {
        return this.shownLogs.filter(log => log.ignore)
      },
      pendingLogs() {
        return this.shownLogs.filter(log => !log.ignore)
      },
    },
    methods: {
      numberWithCommas,
      setFilterState(value) {
        this.filterToggle = value
      },
      getStatus(log) {
        let metadatum = this.getMetadatumLocation(log.location)
        let defaultColor = `${log.severity} lighten-2`
        if (metadatum && metadatum.isDeleted) {
          return {
            icon: 'close',
            color: defaultColor,
          }
        }

        if (this.dirtyData[log.location]) {
          return {
            icon: 'edit',
            color: defaultColor,
          }
        }

        if (log.ignore) {
          return {
            icon: 'done',
            color: defaultColor,
          }
        }

        return {
          icon: log.severity,
          color: defaultColor,
        }
      },
      toggleAll() {
        if (!this.selectedLogs || this.selectedLogs.length) {
          this.selectedLogs = []
        } else {
          this.selectedLogs = this.filteredLogs.slice()
        }
      },
      setSelected(item) {
        this.$store.dispatch('reviewingestionresults/setSelectedLocation', item.location)
        this.$store.dispatch('reviewingestionresults/goToLocation', item.location)
      },
      changeSort(header) {
        if (!header.sortable) return
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = header.value
          this.pagination.descending = false
        }
      },
    },
  }
</script>

<style>
  .location-btn {
    text-transform: none !important;
  }

  .datum-highlight {
    box-shadow: 0 6px 6px -3px rgba(0, 128, 128, 0.2),
      0 10px 14px 1px rgba(0, 128, 128, 0.14),
      0 4px 18px 3px rgba(0, 128, 128, 0.4) !important;
  }

  .execution-detailed-logs {
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
  }

  .bubble {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 12px !important;
  }

  .chip-log-count {
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.20);
  }

  .chipFilter>.v-chip__content {
    cursor: pointer;
  }

  .cell-cell-max-width {
    width: 99% !important;
  }

  .cell-min-width {
    width: 0 !important;
  }
</style>